import { render, staticRenderFns } from "./block-list.vue?vue&type=template&id=569647f1&scoped=true&"
import script from "./block-list.vue?vue&type=script&lang=js&"
export * from "./block-list.vue?vue&type=script&lang=js&"
import style0 from "./block-list.vue?vue&type=style&index=0&id=569647f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569647f1",
  null
  
)

export default component.exports